import { Role } from "@idha/idha-types";
import { Account } from "@idha/idha-types";
import { utilsModule } from "../utils-module";

utilsModule.controller('mainMenuController', ['$scope', '$location', 'SidebarService', 'LoggedUserService', '$translate', 'dialogs', '$state', '$mdSidenav','ordersFilters','$rootScope','currentOrderType','LoginService','serverAddress','rolesService','Account',function ($scope, $location, SidebarService, LoggedUserService, $translate, dialogs, $state, $mdSidenav,ordersFilters,$rootScope,currentOrderType,LoginService,serverAddress,rolesService,Account) {
    $scope.ordersFilters = ordersFilters;

    $scope.userPhotoContainerUrl = `${serverAddress.managerURL}/ImagesContainer/user-photos`;

    $scope.onDefaultClientGroupSelectorChange = function(){
        $rootScope.$emit('filterChange');
    };

    $scope.getLoggedUser = function () {
        return LoggedUserService.loggedUser;
    };

    /*
     * Show the mainMenu
     */
    $scope.showMenu = function () {
        SidebarService.closeRightbar();
        //SidebarService.openLeftbar();
        return $mdSidenav('left').open();
    };

    /*
     * Hide the mainMenu
     */
    $scope.hideMenu = function () {
        //SidebarService.closeLeftbar();
        return $mdSidenav('left').close();
    };

    /*
     * Toggle the mainMenu
     */
    $scope.toggleMenu = function () {
        if (!SidebarService.isLeftBarOpened()) {
            SidebarService.closeRightbar();
        }
        //SidebarService.toggleLeftbar();
        return $mdSidenav('left').toggle();
    };

    /**
     * Controls the menu visibility
     */
    $scope.isVisible = function () {
        return ($location.path() !== '/login');
    };

    /**
     * Controls the menu visibility
     */
    $scope.isInStartMenu = function () {
        return ($state.current.name == 'modules-menu');
    };

    /**
     * Returns the logged user
     */
    $scope.loggedUser = function () {
        return LoggedUserService.loggeduser;
    };

    /**
     * Goes back to the main screen
     */
    $scope.onHomeClick = function () {
        dialogs.confirm($translate.instant('CONFIRM_RETURN_MAIN'),$translate.instant('YES'),$translate.instant('NO')).then(function () {
            $scope.hideMenu();
            if (LoggedUserService.type === "CONFERENTE") {
                $state.go('home');
            } else {              
              $state.go(currentOrderType.getStartRoute() || "/");
            }
        });
    };

    /**
     * Goes back to the start menu
     */
    $scope.onStartMenuClick = function () {
        dialogs.confirm($translate.instant('CONFIRM_RETURN_START_MENU'),$translate.instant('YES'),$translate.instant('NO')).then(function () {
            $scope.hideMenu();
            $state.go('modules-menu');            
        });
    };

    /**
     * Goes to printer config screen
     */
    $scope.onPrinterConfigClick = function () {
        $scope.hideMenu();
        $state.go('printer-params');
    };

    /**
     * Goes to expedition config screen
     */
    $scope.onExpeditionConfigClick = function () {
        $scope.hideMenu();
        $state.go('expedition-params');
    };

    /**
     * Goes to order config screen
     */
    $scope.onOrderConfigClick = function () {
        $scope.hideMenu();
        $state.go('order-params');
    };

    /**
     * Goes to the selected route
     */
    $scope.goToRoute = function(route:string,params?:any){
        $scope.hideMenu();
        $state.go(route,params)
    }

    /**
     * Do instant logoff and calls dialog for user exchange
     */
    $scope.onSwitchUsersClick = function(){

    };

    /**
     * Perform logoff
     */
    $scope.onLogoffClick = function () {
        dialogs.confirm($translate.instant('CONFIRM_LOGOFF'),$translate.instant('YES'),$translate.instant('NO')).then(async function () {
            $scope.hideMenu();
            LoginService.logout();
        });
    };

    $scope.onOrderHistoryClick = function(){
        $state.go('order-list');
        $scope.hideMenu();
    };

    $scope.isCurrentUserAdmin = function(){
		return (LoggedUserService.loggedUser && LoggedUserService.loggedUser.isAdmin == true)||rolesService.hasRole('admin');
	}
    
    $scope.isCurrentUserIdhaAdmin = function(){
        return rolesService.hasRole('idhaAdmin');
	};
    
    (async function checkIfAgencyOrBank(){      
        if(!LoginService.isLogged())  return;
        let result:boolean = false;
        try{
            let accounts:Account[] = await Account.find(
                {filter:{
                    include:[
                        {
                            relation:"agencyThatOwns",
                            scope:{
                                include:["administrativeUnit"]
                            }
                        },
                        {
                            relation:"bank",
                            scope:{
                                include:["administrativeUnit"]
                            }
                        }
                    ],
                    where:{
                        or:[
                            {accountType:'BANK'},
                            {accountType:'AGENCY'}
                        ]
                    }
                }}).$promise;
            
            $scope.agencyAccounts = accounts.filter((acc:Account)=>{
                return acc.accountType == 'AGENCY'
            });
            $scope.bankAccounts = accounts.filter((acc:Account)=>{
                return acc.accountType == 'BANK'
            });
        }catch(e){
            console.error(e);
            result = false;
        }

        return result;
    })()
}]);
